import { DesktopTimePicker } from "@mui/x-date-pickers";
import React from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { TextField, ThemeProvider, createTheme } from "@mui/material";
import { colors } from "../../common/pallette/colors";
import dayjs from "dayjs";

const theme = createTheme({
    components: {
        MuiInputBase: {
            styleOverrides: {
                input: {
                    padding: '8px !important'
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.black.dark,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.black.dark,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.black.dark,
                    },
                    fontSize: '13px',
                },
                notchedOutline: {
                    borderRadius: 0,
                    borderTop: 0,
                    borderRight: 0,
                    borderLeft: 0
                }
            }
        }
    }
})

const CustomTimePicker = (props:any) => {
    const { format, views, value, manageChange, isReadOnly } = props;
    
    return(
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopTimePicker 
                format={format} 
                views={views}
                ampm={false}
                value={value ? dayjs(value) : null}
                disabled={isReadOnly}
                onChange={(v) => {
                    if (!v || v.isValid()) {
                    manageChange(v);
                    }
                }}
                 />
            </LocalizationProvider>
        </ThemeProvider>
        
    )
}

export default CustomTimePicker;